//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "",
  data: function data() {
    return {
      msg_threshold: "",
      used: "",
      total: "",
      simcard: "",
      list: [],
      pageSize: 10,
      currentPage: 1
    };
  },
  computed: {
    // 计算属性的 getter
    // 用来计算当前页的数据
    // 用来计算当前页的数据
    showList: function showList() {
      var start = (this.currentPage - 1) * this.pageSize;
      var end = this.currentPage * this.pageSize;
      return this.list.slice(start, end);
    }
  },
  methods: {
    removeInboxMsg: function removeInboxMsg(index, iindex) {
      var _this = this;

      this.$confirm(this.$t('lang.smartsms.tips2'), this.$t('lang.smartsms.tips'), {
        confirmButtonText: this.$t('lang.smartsms.sure'),
        cancelButtonText: this.$t('lang.smartsms.cancel'),
        type: 'warning'
      }).then(function () {
        // 删除
        _this.$emit("removeInboxMsg", {
          index: index,
          iindex: iindex
        });
      }).catch(function () {});
    },
    refesh: function refesh() {
      this.$emit("refesh");
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
    }
  }
};